<template>
  <cases :moduleInfo="moduleInfo" :moduleFlag="moduleFlag" />
</template>

<script>
  import dataMixins from '@/mixins/pc/data'
  import cases from '@/components/pc/cases'

  export default {
    components: { cases },
    mixins: [dataMixins],
    data() {
      return {
        moduleInfo: this.getModuleData()
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
